import { createFileRoute } from '@tanstack/react-router'
import AdvancesReportList from 'Royalty/components/Test/tabs/AdvancesReportList'

export const Route = createFileRoute('/royalty/reports/advances')({
    component: AdvancesReportList,
})
